<template>
    <div class="all-embracing-component common-share">
        <div class="pop_mask" v-if="popShare" @click="closePop() ">
            <div class="pop_yd" :class="{'wx-h':isWxH5}">
                <img :src="posterImg" alt="">
            </div>
        </div>
        <div class="pop_mask" v-if="originShare" @click="closePop()">
            <div class="jiaohu_box" @click.stop>
                <div class="chat">
                    <img src="https://file.40017.cn/img140017cnproduct/cn/c/marketactivityconfig/components/newimg/newimg-chat.png" />
                </div>
                <div class="tips">
                    <p>点我分享给微信好友</p>
                    <span>好友也可以参与活动</span>
                </div>
            </div>
        </div>
        <canvas id="websiteCommonShareImg" v-show="false"></canvas>
    </div>
</template>

<script>
import Qrcode from 'qrcode'
export default {
    name: 'common-share',
    data() {
        return {
            popShare: false,
            originShare: false,
            Correspond: null,
            imgData: null,
            context: null,
            canvasElem: null,
            posterImg: 'https://pic5.40017.cn/i/ori/15QAzSduPGE.png',
            isWxH5: false,
            closeFn: null,
        }
    },
    mounted() {
        this.isWxH5 =
            window.AllBridge.clientType ===
            window.AllBridge.ClientTypeEnum.WECHAT
    },
    methods: {
        shareEvent(params) {
            // share_common、share_app_guide、share_app_xcx、share_app_wxh5、share_app_fromh5、share_wx_guide、share_wx_list
            try {
                this[`share_${params.data.type}`](params)
                this.closeFn = params.close
            } catch (error) {
                console.log(error)
            }
        },
        async share_common({ data, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion }) {
            if (this.imgData && data.canvasParams.noChange) {
                callback &&
                    callback(this.imgData, this.context, this.canvasElem)
                return
            }
            let shortLink = ''
            let xcxImg = ''
            if (data.canvasParams.codeType === 'xcx') {
                data.shareUrl = await window.AllBridge.linkCompleteOrigionInfo({
                    url: data.shareUrl,
                    fromType: 'xcxCode',
                })
                xcxImg = await this.getXcxQrCode(data.shareUrl)
            } else if (data.canvasParams.codeType !== 'pure') {
                data.shareUrl = await window.AllBridge.linkCompleteOrigionInfo({
                    url: data.shareUrl,
                    fromType: 'normalCode',
                })
                shortLink = await this.getShortLink(data.shareUrl)
            }
            let canvasElem = document.getElementById('websiteCommonShareImg')

            let bgImg = new Image()
            bgImg.setAttribute('crossOrigin', 'anonymous')
            bgImg.src = data.canvasParams.img
            bgImg.onload = () => {
                let bwidth = bgImg.width
                let bheight = bgImg.height
                canvasElem.width = bwidth
                canvasElem.height = bheight
                if (!canvasElem.getContext) {
                    return
                }
                let context = canvasElem.getContext('2d')
                context.clearRect(0, 0, bwidth, bheight)
                context.drawImage(bgImg, 0, 0, bwidth, bheight)
                if (data.canvasParams.codeType === 'xcx') {
                    let img = new Image()
                    img.setAttribute('crossOrigin', 'anonymous')
                    img.src = xcxImg
                    img.onload = () => {
                        context.drawImage(
                            img,
                            Number(data.canvasParams.x),
                            Number(data.canvasParams.y),
                            Number(data.canvasParams.width),
                            Number(data.canvasParams.width)
                        )
                        this.callBackFn(context, canvasElem, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                    }
                } else if (data.canvasParams.codeType !== 'pure') {
                    Qrcode.toDataURL(shortLink, (err, url) => {
                        let codeBg = new Image()
                        codeBg.setAttribute('crossOrigin', 'anonymous')
                        codeBg.src = url
                        codeBg.onload = () => {
                            context.drawImage(
                                codeBg,
                                Number(data.canvasParams.x),
                                Number(data.canvasParams.y),
                                Number(data.canvasParams.width),
                                Number(data.canvasParams.width)
                            )
                            this.callBackFn(context, canvasElem, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                        }
                    })
                } else {
                    this.callBackFn(context, canvasElem, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                }
            }
        },
        share_app_guide(params) {
            this.shareApp(params)
        },
        share_app_xcx(params) {
            this.shareApp(params)
        },
        share_app_wxh5(params) {
            this.shareApp(params)
        },
        shareApp({ data, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion}) {
            if (data.type === 'app_guide') {
                data.shareUrl = `https://m.17u.cn/app/links/web/main_${this.randomString()}?url=${encodeURIComponent(
                    data.shareUrl
                )}&wakePwdId=0&wakeRefid=1635740498&wakeDIC=999999`
            }
            let param = {
                scene: 'session',
                title: window.pageInfo.shareTitle,
                desc: window.pageInfo.shareDesc,
                link: data.shareUrl,
                imgUrl:
                    data.type == 'app_xcx'
                        ? window.pageInfo.shareXcxImage
                        : window.pageInfo.shareDefaultImage,
                type: data.type == 'app_xcx' ? 'wxapp' : 'webpage',
                wxAppInfo:
                    data.type == 'app_xcx'
                        ? {
                              wxUserName: 'gh_0a00573ff7cf',
                              wxPath: `/page/home/webview-ac/webview-ac?src=${encodeURIComponent(
                                  data.shareUrl
                              )}&isSocket=${_eaid}`,
                          }
                        : null,
            }
            _tc_bridge_bar.share_weixin_msg({
                param,
                callback: (res) => {
                    let dbody = res && res.CBData && (JSON.parse(res.CBData))
                    if (dbody && (dbody.status === '0')) {
                        this.shareTrack(`tapp|share_${data.type}|share_weixin_msg|${dbody.shareType}`, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                    }
                    callback && callback(res)
                },
            })
        },
        share_app_fromh5({ data, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion }) {
            let param = {
                tcsharetxt: window.pageInfo.shareTitle,
                tcsharedesc: window.pageInfo.shareDesc,
                tcshareurl: data.shareUrl,
                tcshareimg: window.pageInfo.shareXcxImage,
                wxAppInfo: {
                    wxUserName: 'gh_0a00573ff7cf',
                    wxPath: `/page/home/webview-ac/webview-ac?src=${encodeURIComponent(
                        data.shareUrl
                    )}&isSocket=${_eaid}`,
                },
            }
            //调起分享面板
            _tc_bridge_bar.shareInfoFromH5({
                param,
                callback: (res) => {
                    let dbody = res && res.CBData && (JSON.parse(res.CBData))
                    if (dbody && (dbody.status === '0')) {
                        this.shareTrack(`tapp|share_app_fromh5|shareInfoFromH5|${dbody.shareType}`, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                    }
                    callback && callback(res)
                },
            })
        },
        randomString(e) {
            e = e || 18
            var t =
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
                a = t.length,
                n = ''
            for (var i = 0; i < e; i++)
                n += t.charAt(Math.floor(Math.random() * a))
            return n
        },
        share_wx_guide(params) {
            this.posterImg = params.data.guideImg
            this.popShare = true
            this.initShareOption(params)
        },
        async share_wx_list(params) {
            this.originShare = true
            this.Correspond = await window.AllBridge.getWeixinCorrespond()
            this.initShareOption(params)
        },
        getXcxQrCode(shareUrl) {
            return new Promise((res, rej) => {
                window.AllBridge.request({
                    url: '/actgateway/marketcenter.java.active.template.website/qr/getQrCode',
                    methods: 'get',
                    params: {
                        fullLink: shareUrl,
                        type: 2,
                    },
                })
                    .then(({ data }) => {
                        if (data.code === '0000') {
                            res(data.result)
                        } else {
                            res('')
                        }
                    })
                    .catch(() => {
                        res('')
                    })
            })
        },
        getShortLink(url) {
            return new Promise((res, rej) => {
                window.AllBridge.request({
                    url: '/actgateway/marketcenter.java.active.template.website/qr/getShort',
                    method: 'post',
                    data: {
                        longUrl: url,
                    },
                })
                    .then(({ data }) => {
                        if (data.result) {
                            res(data.result)
                        } else {
                            this.$UI.toast('活动太火爆了,请稍后再试')
                        }
                    })
                    .catch((err) => {
                        this.$UI.toast('活动太火爆了,请稍后再试')
                    })
            })
        },
        initShareOption({ data, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion }) {
            let btnList = []
            if (data.type === 'wx_list') {
                this.Correspond.share({
                    shareList: [
                        {
                            //list数组，可设置多个按钮
                            show: true, //是否显示此按钮
                            type: 0, //索引，与下面的btnList数组一致
                            shareStyle:
                                'position: fixed;bottom:0rpx;left: 20rpx;width:720rpx; height: 266rpx;z-index:100', //外层view的样式，定位需要
                            btnStyle:
                                'width:7200rpx; height: 266rpx;opacity:0;', //btn按钮样式，宽高与上面的一致即可，宽高是一定要的，不然容器撑不开
                        },
                    ],
                })
                btnList = [
                    {
                        currentPath: location.hostname + location.pathname,
                        title: window.pageInfo.shareTitle,
                        imageUrl: window.pageInfo.shareXcxImage,
                        path: `/page/home/transfer/transfer?shareUrl=${encodeURIComponent(
                            `/page/home/webview/webview?src=${encodeURIComponent(
                                data.shareUrl
                            )}&isSocket=${_eaid}`
                        )}`,
                        isMiniApp: true,
                    },
                    {
                        currentPath: location.hostname + location.pathname,
                        title: window.pageInfo.shareTitle,
                        imageUrl: window.pageInfo.shareXcxImage,
                        path: `/page/home/transfer/transfer?shareUrl=${encodeURIComponent(
                            `/page/home/webview/webview?src=${encodeURIComponent(
                                data.shareUrl
                            )}&isSocket=${_eaid}`
                        )}`,
                        isMiniApp: true,
                    },
                ]
                this.shareTrack(`WECHAT_APP|share_wx_list`, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
                wx.miniProgram.postMessage({
                    data: {
                        btnList,
                        shareInfo: {
                            isMiniApp: true,
                            showBack: false,
                            currentPath: location.hostname + location.pathname, // 当前页面路径，不需要参数
                            title: window.pageInfo.shareTitle, // 默认同程艺龙
                            path: `/page/home/transfer/transfer?shareUrl=${encodeURIComponent(
                                `/page/home/webview/webview?src=${encodeURIComponent(
                                    data.shareUrl
                                )}&isSocket=${window['_eaid']}`
                            )}`, // 默认当前页面路径
                            url: data.shareUrl,
                            imageUrl: window.pageInfo.shareXcxImage, // 支持PNG及JPG，不传入 imageUrl 则使用默认截图。显示图片长宽比是 5:4
                        },
                    },
                })
            } else {
                const shareInfo = {
                    title: window.pageInfo.shareTitle,
                    desc: window.pageInfo.shareDesc,
                    link: data.shareUrl,
                    img: window.pageInfo.shareDefaultImage,
                    xcximg: window.pageInfo.shareXcxImage,
                    wxId: data.onlyWXH5 ? null : 'gh_0a00573ff7cf',
                    wxPath: data.onlyWXH5
                        ? null
                        : `/page/home/transfer/transfer?shareUrl=${encodeURIComponent(
                              `/page/home/webview/webview?src=${encodeURIComponent(
                                  data.shareUrl
                              )}&isSocket=${window['_eaid']}`
                          )}`,
                    $nodeId: $nodeId, //以下相关用于埋点处理
                    $nodeLabel: $nodeLabel,
                    $nodeType: $nodeType,
                    $nodeVersion: $nodeVersion
                }
                window.AllBridge.showShareMenu(shareInfo)
            }

            callback && callback()
        },
        closePop() {
            this.popShare = false
            this.originShare = false
            this.closeFn()
        },
        callBackFn(context, canvasElem, callback, $nodeId, $nodeLabel, $nodeType, $nodeVersion) {
            let imgData = canvasElem.toDataURL('image/png')
            this.imgData = imgData
            this.context = context
            this.canvasElem = canvasElem
            this.shareTrack(`all|share_common`, $nodeId, $nodeLabel, $nodeType, $nodeVersion)
            callback && callback(imgData, context, canvasElem)
        },
        shareTrack(type, $nodeId, $nodeLabel, $nodeType, $nodeVersion) {
            window.AllBridge
                .allCompEventTrack({
                    $nodeId: $nodeId,
                    $nodeLabel: $nodeLabel,
                    $nodeType: $nodeType,
                    $nodeVersion: $nodeVersion,
                    action: 'share_event',
                    value: {
                        sence: '点击分享',
                        type: `${type}`
                    }
                })
        }
    },
}
</script>

<style scoped lang='less'>
.common-share {
    .pop_mask {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.75);
        z-index: 100;
        .pop_yd {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
    .jiaohu_box {
        position: fixed;
        left: 50%;
        bottom: 10px;
        transform: translate(-50%, 0%);
        -webkit-transform: translate(-50%, 0%);
        width: 96%;
        display: flex;
        align-items: center;
        padding: 20px 0;
        background-color: #fff;
        border-radius: 10px;
        color: #333;
        .chat {
            width: 90px;
            text-align: center;
            img {
                width: 60px;
                margin: 0 auto;
            }
        }
        .tips {
            line-height: 27.5px;
            p {
                font-size: 16px;
            }
            span {
                font-size: 13.5px;
            }
        }
    }
}
</style>